module.exports = __webpack_public_path__ + "img/layers.1c1102d7.svg";